import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable, map } from 'rxjs';

export interface LeaderboardEntry {
  id: number;
  first_name: string;
  last_name: string;
  state: string;
  country: string;
  total_score: number;
  contest_name: string;
  contest_category: string;
}

@Injectable({
  providedIn: 'root'
})
export class RankingService {
  private apiUrl = 'https://molhy.com/users/wp-json/molhy/v1/leaderboard';

  constructor(private http: HttpClient) {}

  getLeaderboard(): Observable<LeaderboardEntry[]> {
    return this.http.get<any[]>(this.apiUrl).pipe(
      map(response => {
        return response.map(entry => ({
          ...entry,
          contest_category: this.extractCategory(entry.contest_name)
        }));
      })
    );
  }

  private extractCategory(contestName: string): string {
    if (!contestName) return 'unknown';
    
    const parts = contestName.split(' ');
    return parts.length > 1 ? parts[1] : contestName;
  }
}
